import {GET_DATA_MAIN_PLANTEMPLATE, SET_DATA_MAIN_PLANTEMPLATE,GET_DATA_KHName_PLANTEMPLATE,
    GET_DATA_Delete_PLANTEMPLATE
} from '../actions/actionTypes'
import {RequertMainPlanTemplateFaileAction, GetDataMainPlanTemplateSuccessAction,
    GetDataKHNamePlanTemplateSuccessAction,RequertKHNamePlanTemplateFaileAction,
    GetDataDeletePlanTemplateSuccessAction,RequertDeleteTemplateFaileAction,
    IsResultAction } from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataMain(action){
    try{
        const DataMain = yield Api.GetDataMainFromApi(action.DataMain);
        yield put(GetDataMainPlanTemplateSuccessAction(DataMain))
    }catch(error){
        yield put(RequertMainPlanTemplateFaileAction(error))
    }
}
export function* watchGetDataMain(){
    yield takeLatest(GET_DATA_MAIN_PLANTEMPLATE, GetDataMain)
}

function* GetDataKHName(action){
    try{
        const DataKHName = yield Api.GetDataKHNameFromApi(action.DataKHName);
        yield put(GetDataKHNamePlanTemplateSuccessAction(DataKHName))
    }catch(error){
        yield put(RequertKHNamePlanTemplateFaileAction(error))
    }
}
export function* watchGetDataKHName(){
    yield takeLatest(GET_DATA_KHName_PLANTEMPLATE, GetDataKHName)
}

function* SetDataMain(action){
    try{
        const isResult = yield Api.SetDataMainFromApi(action.DataMain);
        if(isResult)
        {
            yield put(IsResultAction(isResult))
        }
        else
        {
            yield put(RequertMainPlanTemplateFaileAction("error"))
        }
    }catch(error){
        yield put(RequertMainPlanTemplateFaileAction(error))
    }
}
export function* watchSetDataMain(){
    yield takeLatest(SET_DATA_MAIN_PLANTEMPLATE, SetDataMain)
}

function* DeleteTemplate(action){
    try{
        const DataDelete = yield Api.DeleteTemplate(action.DataDelete);
        yield put(GetDataDeletePlanTemplateSuccessAction(DataDelete))
    }catch(error){
        yield put(RequertDeleteTemplateFaileAction(error))
    }
}
export function* watchDeleteTemplate(){
    yield takeLatest(GET_DATA_Delete_PLANTEMPLATE, DeleteTemplate)
}